import ReactDOM from "react-dom/client";
import "styles/index.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import App from "app/App";
import { insideInstalledApp } from "common/utils";
import i18n from "features/shared/i18n";

dayjs.extend(utc);
dayjs.extend(isToday);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

i18n.locale = "ja";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

declare global {
  interface Window {
    deferredPrompt?: any;
    ReactNativeWebView?: any;
    parentsAppHostRegionCode?: string;
    parentsAppHostLanguageCode?: string;
    parentsAppPlatform?: string;
    parentsAppVersion?: string;
    parentsBuildVersion?: string;
  }
}

if (insideInstalledApp()) {
  window.resizeBy(1024 - window.innerWidth, 768 - window.innerHeight);
}
